export const DRIVER = 'Driver';
export const VEHICLE = 'Vehicle';
export const ITEM_PER_PAGE_OPTIONS = [
  { label: '20', value: '20' },
  { label: '50', value: '50' },
  { label: '100', value: '100' }
];



// WEBPACK FOOTER //
// ./src/features/common/GlobalSearchBar/SearchResultGrid/content.js